export function createDiamondImage(color, size = 24) {
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size

  const context = canvas.getContext('2d')
  const padding = 2
  const half = size / 2

  context.fillStyle = color
  context.beginPath()
  context.moveTo(half, padding)
  context.lineTo(size - padding, half)
  context.lineTo(half, size - padding)
  context.lineTo(padding, half)
  context.closePath()
  context.fill()

  const imageData = context.getImageData(0, 0, size, size)

  return {
    width: size,
    height: size,
    data: imageData.data
  }
}

export function addDiamondImage(map, imageId, color) {
  if (map.hasImage(imageId)) {
    return
  }

  map.addImage(imageId, createDiamondImage(color))
}
